module.exports = __webpack_public_path__ + "images/backgrounds/orange-blur.07a3436eabfd187ee94a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/orange-blur.png
// module id = AqoP
// module chunks = 2